import { section } from "@/glow";
import { animateStandard, shouldAnimate } from "@/lib/animation";

section("promotion-grid", {
  onLoad() {
    if (shouldAnimate(this.container)) {
      this.animatePromotionGrid = animateStandard(this.container);
    }
  },

  onUnload() {
    this.animatePromotionGrid?.destroy();
  },
});
